export const CANCELLATION_COMPLETE = "Cancellation Complete";
export const BOOKING_HAS_BEEN_CANCELED_BODY =
  "Your booking has been canceled. A confirmation email will be sent shortly. If you need to rebook this trip, you can search for new flights whenever you’re ready.";
export const DONE = "Done";
export const DONE_BUTTON_ARIA_LABEL = "Close CFAR modal";
